import { useIntl } from '@olxpwa-lib/i18n/client';

export const useFormatNumber = () => {
  const { formatNumber } = useIntl();

  return formatNumber;
};
